<template>
  <div class="el-select" style="width:100%;">
    <el-popover
      ref="popover"
      placement="bottom-start"
      :width="width"
      trigger="click"
      @show="handlePopoverShow"
      @hide="handlePopoverHide">
      <el-input
        slot="reference"
        type="text"
        :value="label"
        :placeholder="placeholder"
        @mouseenter.native="inputHovering = true"
        @mouseleave.native="inputHovering = false"
        readonly>
        <template slot="suffix">
          <i v-if="!showClose" :class="['el-select__caret', 'el-input__icon', 'el-icon-' + iconClass]"></i>
          <i v-if="showClose" class="el-select__caret el-input__icon el-icon-circle-close" @click.stop="handleClearClick"></i>
        </template>
      </el-input>
      <slot name="default"></slot>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: 'BaseSelect',
  props: {
    placeholder: String,
    label: String,
    width: [Number, String],
    clearable: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      iconClass: 'arrow-up',
      inputHovering: false,
    }
  },
  computed: {
    showClose () {
      return this.clearable && this.inputHovering
    }
  },
  methods: {
    updatePopover() {
      this.$refs.popover.updatePopper()
    },
    hidePopover() {
      this.$refs.popover.doClose()
    },
    handlePopoverShow() {
      this.iconClass = 'arrow-up is-reverse'
      this.$emit('show')
    },
    handlePopoverHide() {
      this.iconClass = 'arrow-up'
      this.$emit('hide')
    },
    handleClearClick() {
      this.$emit('clear')
    }
  }
}
</script>
